import React from 'react';
import './index.css';

const Spinner = ({fixed}) => {
    return (
        <div className="text-center p-2">
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="46"/>
            </svg>
        </div>
    );
};

export default Spinner;